import { Outlet, useLocation } from 'react-router-dom'
import DashboardLayout from 'components/layout/dashboard/DashboardLayout'
import Notification from 'components/notifications/Notification'
import BBookNav from './components/BBookNav'
import BBookRefresh from './components/BBookRefresh'
import { useT } from './hooks'
import './bBook.css'

const PAGE_NAMES = { '/b-book': 'b_book', '/b-book/moves': 'b_book_moves', '/b-book/pnl': 'b_book_pnl', '/b-book/a-vs-b': 'b_book_report' }

// One frame for the four B-book screens: the dashboard chrome and the tab bar stay mounted, only the screen below changes.
const BBookLayout = () => {
  const { t } = useT()
  const { pathname } = useLocation()
  const page = PAGE_NAMES[pathname.replace(/\/$/, '')] || 'b_book'

  return (
    <DashboardLayout page={t(`pages_name.${page}`)}>
      <div className='b_book_page'>
        <Notification />
        <div className='b_book_appbar'>
          <BBookNav />
          <BBookRefresh />
        </div>
        <div key={pathname} className='b_book_screen'>
          <Outlet />
        </div>
      </div>
    </DashboardLayout>
  )
}

export default BBookLayout
